import React, { useState, useEffect } from "react";
import "./FeeshKees.css";

const FeeshKees = () => {
  const startDate = new Date("2024-05-28T00:00:00Z"); // Set the specific start date

  const [isClicked, setIsClicked] = useState(false);
  const [defaultImage, setDefaultImage] = useState("");
  const [counter, setCounter] = useState((Date.now() - startDate) * 100);

  const rerollImage = () => {
    const randomImage = Math.random() > 0.5 ? "normie.png" : "boop.png";
    setDefaultImage(randomImage);
  };

  const handleTouchEnd = React.useCallback(() => {
    setIsClicked(false);
  }, []);

  const handleShortKiss = React.useCallback(() => {
    const audio = new Audio("kiss-1.mp3");
    audio.play();
    setIsClicked(true);
    setCounter((c) => c + 1);
    setTimeout(() => {
      handleTouchEnd();
    }, 200);
  }, [handleTouchEnd]);

  const handleLongKiss = React.useCallback(() => {
    const audio = new Audio("long-kiss.mp3");
    audio.play();
    setIsClicked(true);
    setCounter((c) => c + 1);
    setTimeout(() => {
      handleTouchEnd();
    }, 700);
  }, [handleTouchEnd]);

  useEffect(() => {
    rerollImage();
  }, []);

  const getImageSrc = () => {
    return isClicked ? "smooch.png" : defaultImage;
  };

  return (
    <div className="image-switcher-container">
      <img
        src={getImageSrc()}
        height={300}
        width={300}
        alt="you just got kissed by a feesh!"
        className="center-image"
      />
      <div className="buttons">
        <button className="kees" onClick={handleShortKiss}>
          keesh
        </button>
        <button className="kees" onClick={handleLongKiss}>
          smooch
        </button>
        <div className="counter">keeses gived: {counter}</div>
      </div>
    </div>
  );
};

export default FeeshKees;
